/**
 * src/components/platform/FeatureCard.js
 *
 * Tarjeta de característica de la plataforma.
 * Props: { icon, title, description, color }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('FeatureCard', ({ icon, title, description, color = 'green' }) => {
    return h('article', { className: `feat-card feat-card--${color}` },
        h('div', { className: 'feat-card__icon-wrap' },
            h('span', { className: 'feat-card__icon' }, icon)
        ),
        h('h3', { className: 'feat-card__title' }, title),
        h('p',  { className: 'feat-card__desc' }, description)
    )
})
